import script from "./PrintButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintButton.vue?vue&type=script&setup=true&lang=js"

import "./PrintButton.vue?vue&type=style&index=0&id=5a08ba95&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a08ba95"]])

export default __exports__